import { Configuration } from './runtime';
import { handleAuthFailure, isAuthFailure } from '../providers/authEvents';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const apiConfig = new Configuration({
  basePath: API_BASE_URL,
  middleware: [
    {
      pre: async (context) => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (token) {
          return {
            url: context.url,
            init: {
              ...context.init,
              headers: {
                ...context.init.headers,
                Authorization: `Bearer ${token}`,
              },
            },
          };
        }
        return { url: context.url, init: context.init };
      },
      // On an expired/invalid session, clear auth and signal a logout+redirect. Covers every call
      // made through the generated API client.
      post: async (context) => {
        if (context.response && isAuthFailure(context.response.status)) {
          handleAuthFailure();
        }
        return context.response;
      },
    },
  ],
});
